<template>
  <a
    :href="link ? link : null"
    role="button"
    class="kk-text-link"
    :class="[
      `kk-text-link--${size}`,
      `kk-text-link--${theme}`,
      `kk-text-link--${type}`,
    ]"
    @click="$emit('click')"
  >
    <span class="kk-text-link__text">
      {{ text }}
    </span>
    <KkIcon
      v-if="isShowIcon"
      class="kk-text-link__icon"
      name="ic_arrowRight_line_semibold_lg"
      :size="iconSize"
    />
  </a>
</template>

<script>
import KkIcon from '../../KkIcon';

export const KK_TEXT_LINK_TYPE_LIST = ['standalone', 'inline'];
export const KK_TEXT_LINK_SIZE_LIST = ['sm', 'md', 'lg'];
export const KK_TEXT_LINK_THEME_LIST = ['primary', 'secondary'];

export default {
  name: 'KkTextLink',
  components: {
    KkIcon,
  },
  props: {
    type: {
      type: String,
      default: 'inline',
      validator: (val) => KK_TEXT_LINK_TYPE_LIST.indexOf(val) !== -1,
    },
    link: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => KK_TEXT_LINK_SIZE_LIST.indexOf(val) !== -1,
    },
    text: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: 'primary',
      validator: (val) => KK_TEXT_LINK_THEME_LIST.indexOf(val) !== -1,
    },
  },
  emits: ['click'],
  computed: {
    isShowIcon() {
      return this.type === 'standalone';
    },
    iconSize() {
      return this.size === 'sm' ? '2xs' : 'xs';
    },
  },
};
</script>
